import { ExecutionTimeoutFrequency } from "@pages/workflow-page/SchedulePipelinesForm";
import { ScheduleTiming } from "@pages/workflow-page/modals/schedule-workflow";
import { Moment } from 'moment';

const servers = ["pi-edge-and-dom"];
const databases = ["AnalysisDB"];
const sinkOptions = [{ label: 'S3', value: 'S3', type: 's3' }]
const modeOptions = [
    { label: "Append", value: "Append" },
    { label: "Overwrite", value: "Overwrite" },
    { label: "Ignore", value: "Ignore" },
]

const tagFilterTypeOptions = [
    { label: "Number", value: "number" },
    { label: "String", value: "string" },
    { label: "Null values", value: "null" },
]

const conditionTypeOptions = [
    { label: "Equal to", value: "equal_to" },
    { label: "Not Equal to", value: "not_equal_to" },
    { label: "Greater than", value: "greater_than" },
    { label: "Less than", value: "less_than" },
    { label: "Greater than or Equal to", value: "greater_than_or_equal_to" },
    { label: "Less than or Equal to", value: "less_than_or_equal_to" },
]

const interploted_valuesOptions = [
    { label: "Sample Values Every", value: "sample_values" },
    { label: "Use Key Column", value: "key_column" },
]

const requestTypeOptions = [
    { label: "Raw", value: "raw" },
    { label: "Real Time", value: "real_time" },
    { label: "Interpolated", value: "interpolated" },
]

const outputFormatOptions = [
    { label: "Json", value: "json" },
    { label: "Csv", value: "csv" },
]
const realTimeOptions = [
    { label: "Current", value: "current" },
    { label: "Live", value: "live" },
]

type Attribute = {
    attr_categories?: string;
    attr_id: string;
    attr_name?: string;
    attr_template?: string;
    attr_trait?: string;
    attr_type?: string;
    creation_date: string;
    effective_date: string;
    modify_date: string;
    obsolete_date: string;
    pipoint_id?: string;
    pipoint_name?: string;
    pipoint_type?: string;
    pipoint_class?: string;
    uom?: string;
    template?: string;
    path: string;
};

export type RootType = {
    element_id: string;
    element_name: string;
    parent: string;
    children: RootType[];
    parent_id?: string;
    path: string;
    creation_date: string;
    effective_date: string;
    modify_date: string;
    attributes: Attribute[]
};

type scheduleInfoForDagGenDto = {
    dag_id: string;
    cronExpression: string;
    scheduleType: string;
    mins: number;
    days: number | string;
    weekOfTheMonth: number;
    hrs: number;
    retries: number;
    retryDelay: number;
    execution_timeout: number | null;
    execution_timeout_frequency: ExecutionTimeoutFrequency;
    overrideNotificationEmail: boolean;
    notificationEmails: string;
    notificationType: string;
    scheduleAdvancedMode: boolean;
    startDate: string;
    weekDays: string;
    months: number;
    scheduleTimingInfo: ScheduleTiming,
    runOnceExecutionDate: Moment,
    formattedRunOnceExecutionDate: string;
    cluster?: string;
    max_active_runs: string,
    catchup: boolean,
    exponential_backoff: boolean
    schedule_interval: string;
} | null;

export type ModelRequestType = {
    dagGenDto: scheduleInfoForDagGenDto;
    dataBaseName: string;
    id: number;
    licenseId: string;
    modelRequestName: string;
    nodeName: string;
    requestJson: string;
    serverName: string;
    sinkKind: string;
    sinkName: string;
    tagSelections: string[];
    requestType: string;
    realtime_values: string;
    frequency: string;
    frequencyType: string;
    period_ms: string
    tagSelectedType: string;
    created: string;
    all_descendants:boolean;
    output_format: string;
}

const formTitle: Record<number, string> = {
    0: "Tag Selection",
    1: "Data Configuration",
    2: "Sink Options",
    3: "Schedule Options"
}


export { servers, databases, sinkOptions, modeOptions, tagFilterTypeOptions, conditionTypeOptions, interploted_valuesOptions, formTitle, requestTypeOptions, realTimeOptions,outputFormatOptions };